// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getDocumentos as listDocumentosAPI,
    getDocumentosPreview as listDocumentosPreviewAPI,
    getDocumento as getDocumentoAPI,
    getDocumentoPreview as getDocumentoPreviewAPI,
    addDocumento as addDocumentoAPI,
    updateDocumento as updateDocumentoAPI,
    deleteDocumento as deleteDocumentoAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { documentosApiResponseError, documentosApiResponseSuccess } from './actions';
import { DocumentosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getDocumento({ payload: { id } }) {
    try {
        const response = yield call(getDocumentoAPI, id );
        const documentoItem = response.data.data;
        yield put(documentosApiResponseSuccess(DocumentosActionTypes.GET_DOCUMENTO, documentoItem));
    } catch (error) {
        yield put(documentosApiResponseError(DocumentosActionTypes.GET_DOCUMENTO, error));
    }
}

function* getDocumentoPreview({ payload: { id } }) {
    try {
        const response = yield call(getDocumentoPreviewAPI, id );
        const documentoItem = response.data.data;
        yield put(documentosApiResponseSuccess(DocumentosActionTypes.GET_DOCUMENTO_PREVIEW, documentoItem));
    } catch (error) {
        yield put(documentosApiResponseError(DocumentosActionTypes.GET_DOCUMENTO_PREVIEW, error));
    }
}

function* addDocumento({payload:documento}){
    try{
        const response = yield call(addDocumentoAPI,{...documento})
        const documentoItem = response.data
        yield put(documentosApiResponseSuccess(DocumentosActionTypes.ADD_DOCUMENTO,documentoItem))
    } catch(error){
        yield put(documentosApiResponseError(DocumentosActionTypes.ADD_DOCUMENTO,error))
    }
}

function* updateDocumento({payload:documento}){
    try{
        const response = yield call(updateDocumentoAPI,{...documento})
        const documentoItem = response.data.data
        yield put(documentosApiResponseSuccess(DocumentosActionTypes.UPDATE_DOCUMENTO,documentoItem))
    }catch(error){
        yield put(documentosApiResponseError(DocumentosActionTypes.UPDATE_DOCUMENTO,error))
    }
}
function* deleteDocumento({payload:{id}}){
    try{
        const response = yield call(deleteDocumentoAPI,id)
        const documentoItem = response.data.id
        yield put(documentosApiResponseSuccess(DocumentosActionTypes.DELETE_DOCUMENTO,documentoItem))
    }catch(error){
        yield put(documentosApiResponseError(DocumentosActionTypes.DELETE_DOCUMENTO,error))
    }
}

/**
 * List contactos
 */
function* listDocumentos({payload:params}) {
    try {
        const response = yield call(listDocumentosAPI, { ...params });
        const listaDocumentos = response.data.data;
        yield put(documentosApiResponseSuccess(DocumentosActionTypes.LIST_DOCUMENTOS, listaDocumentos));
    } catch (error) {
        yield put(documentosApiResponseError(DocumentosActionTypes.LIST_DOCUMENTOS, error));
    }
}

function* listDocumentosPreview({payload:params}) {
    try {
        const response = yield call(listDocumentosPreviewAPI, { ...params });
        const listaDocumentos = response.data.data;
        yield put(documentosApiResponseSuccess(DocumentosActionTypes.LIST_DOCUMENTOS_PREVIEW, listaDocumentos));
    } catch (error) {
        yield put(documentosApiResponseError(DocumentosActionTypes.LIST_DOCUMENTOS_PREVIEW, error));
    }
}

export function* watchGetDocumento(): any {
    yield takeEvery(DocumentosActionTypes.GET_DOCUMENTO, getDocumento);
}

export function* watchGetDocumentoPreview(): any {
    yield takeEvery(DocumentosActionTypes.GET_DOCUMENTO_PREVIEW, getDocumentoPreview);
}

export function* watchListDocumentos(): any {
    yield takeEvery(DocumentosActionTypes.LIST_DOCUMENTOS, listDocumentos);
}

export function* watchListDocumentosPreview(): any {
    yield takeEvery(DocumentosActionTypes.LIST_DOCUMENTOS_PREVIEW, listDocumentosPreview);
}

export function* watchAddDocumento():any{
    yield takeEvery(DocumentosActionTypes.ADD_DOCUMENTO,addDocumento)
}
export function* watchUpdateDocumento():any{
    yield takeEvery(DocumentosActionTypes.UPDATE_DOCUMENTO,updateDocumento)
}
export function* watchDeleteDocumento():any{
    yield takeEvery(DocumentosActionTypes.DELETE_DOCUMENTO,deleteDocumento)
}


function* documentosSaga(): any {
    yield all([
        fork(watchGetDocumento),
        fork(watchGetDocumentoPreview),
        fork(watchListDocumentos),
        fork(watchListDocumentosPreview),
        fork(watchAddDocumento),
        fork(watchUpdateDocumento),
        fork(watchDeleteDocumento),
    ]);
}

export default documentosSaga;
